import Head from "next/head";
import { getPaginatedPath, getRobotsMetaContent } from "utils/utils";

const TanyaHomeSEO: React.FC = () => (
  <Head>
    <title>
      Aplikasi foto soal untuk menjawab soal Matematika, Fisika, Kimia - CoLearn
    </title>
    <meta
      property="title"
      content="Aplikasi foto soal untuk menjawab soal Matematika, Fisika, Kimia - CoLearn"
    />
    <meta
      name="description"
      content="
      Aplikasi belajar untuk menjawab soal Matematika, Fisika. Gunakan fitur dengan cara foto soal dan dapatkan video pembahasan yang telah diverifikasi ahli. Tersedia untuk SD, SMP, SMA."
    />
    <meta
      name="keywords"
      content="aplikasi matematika, aplikasi jawaban matematika,aplikasi yang bisa menjawab soal matematika dengan cara difoto,aplikasi pemecah soal matematika,aplikasi matematika sma,pemecah soal matematika,aplikasi belajar matematika,aplikasi menjawab soal matematika,foto soal matematika,aplikasi matematika smp,foto soal,aplikasi foto soal matematika,aplikasi foto soal keluar jawaban,aplikasi foto soal,jawab soal matematika dengan foto,aplikasi untuk mengerjakan soal matematika dengan cara di foto"
    />
    <meta
      property="og:title"
      content="Aplikasi foto soal untuk menjawab soal Matematika, Fisika, Kimia - CoLearn"
    />
    <meta
      property="og:description"
      content="
      Aplikasi belajar untuk menjawab soal Matematika, Fisika. Gunakan fitur dengan cara foto soal dan dapatkan video pembahasan yang telah diverifikasi ahli. Tersedia untuk SD, SMP, SMA."
    />
    <meta
      property="og:image"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/assets/share-og.jpg`}
    />
    <meta
      property="og:url"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/tanya`}
    />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="robots" content={getRobotsMetaContent()} />
    <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SITE_URL}/tanya/`} />
  </Head>
);

type ITanyaQuestionsSEOProps = {
  page: number;
  totalPages: number;
};

const TanyaQuestionsSEO: React.FC<ITanyaQuestionsSEOProps> = ({
  page,
  totalPages
}) => (
  <Head>
    <title>Semua video | CoLearn{page > 1 ? ` - halaman ${page}` : ""}</title>
    <meta name="description" content="Video solusi dari Tanya untuk jawab" />
    <meta property="og:title" content="Semua video" />
    <meta
      property="og:description"
      content="Video solusi dari Tanya untuk jawab"
    />
    <meta
      property="og:image"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/assets/share-og.jpg`}
    />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@CoLearn_ID" />
    <meta name="robots" content={getRobotsMetaContent()} />
    <link
      rel="canonical"
      href={`${process.env.NEXT_PUBLIC_SITE_URL}/tanya/questions/page/${page}`}
    />
    {page > 1 && (
      <link
        rel="prev"
        href={`${process.env.NEXT_PUBLIC_SITE_URL}/tanya/questions/page/${
          page - 1
        }`}
      />
    )}
    {page < totalPages && (
      <link
        rel="next"
        href={`${process.env.NEXT_PUBLIC_SITE_URL}/tanya/questions/page/${
          page + 1
        }`}
      />
    )}
  </Head>
);

interface ITanyaListSEOProps {
  category: string;
  categoryTitle: string;
  categorySlug: string;
  subject: string;
  grade: string;
  page: number;
  totalPages: number;
}

const TanyaListSEO: React.FC<ITanyaListSEOProps> = ({
  category,
  categorySlug,
  categoryTitle,
  subject,
  grade,
  page,
  totalPages
}) => (
  <Head>
    <title>
      Kumpulan Contoh Soal {categoryTitle} - {subject} Kelas {grade} | CoLearn
      {page > 1 ? ` - halaman ${page}` : ""}
    </title>
    <meta
      name="description"
      content={`Video solusi dari Tanya untuk jawab ${subject} - ${grade}}`}
    />
    <meta property="og:title" content={categoryTitle} />
    <meta
      property="og:description"
      content={`Video solusi dari Tanya untuk jawab ${subject} - ${grade}}`}
    />
    <meta
      property="og:image"
      content={`${process.env.NEXT_PUBLIC_SITE_URL}/assets/share-og.jpg`}
    />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="robots" content={getRobotsMetaContent()} />
    <link
      rel="preconnect"
      href="coln-prd-sg-s3-ads-pub.s3.ap-southeast-1.amazonaws.com"
    />
    <link
      rel="canonical"
      href={getPaginatedPath(
        `${process.env.NEXT_PUBLIC_SITE_URL}/tanya/${category}/${grade}/${subject}/${categorySlug}`,
        page
      )}
    />
    {page > 1 && (
      <link
        rel="prev"
        href={getPaginatedPath(
          `${process.env.NEXT_PUBLIC_SITE_URL}/tanya/${category}/${grade}/${subject}/${categorySlug}`,
          page - 1
        )}
      />
    )}
    {page < totalPages && (
      <link
        rel="next"
        href={getPaginatedPath(
          `${process.env.NEXT_PUBLIC_SITE_URL}/tanya/${category}/${grade}/${subject}/${categorySlug}`,
          page + 1
        )}
      />
    )}
  </Head>
);

export { TanyaHomeSEO, TanyaQuestionsSEO, TanyaListSEO };
